import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDataAuth } from './useDataAuth';
import { selectCompany, initCompanyConfig, startViewAsCompany, endViewAsCompany as endViewAsCompanyAction, setConfigurationDataCompany } from '../redux/actions/companyConfig';
import { safeParseJSON } from '../utils/jsonValidator';

export const useCompanyConfiguration = () => {
    const dispatch = useDispatch();
    const [{ userSession }] = useDataAuth();

    const {
        companyInfo,
        userCompanies,
        selectedCompanyId,
        isLoading,
        error,
        companyViewInfo,
        companyViewSelectedId,
        companyViewActive,
    } = useSelector((state) => state.companyConfig);

    const init = useCallback(() => {
        if (userSession?.token) {
            dispatch(initCompanyConfig(userSession.token));
        }
    }, [dispatch, userSession?.token]);

    useEffect(() => {
        if (!userSession?.token) return;

        if (userCompanies.length === 0) {
            init();
        }
    }, [userSession?.token, userCompanies.length, init]);

    useEffect(() => {
        if (!companyViewInfo && !companyInfo)
            return;
        if (companyViewInfo || companyInfo) {
            const configuration = companyViewActive ? safeParseJSON(companyViewInfo.configuration) : safeParseJSON(companyInfo.configuration)
            dispatch(setConfigurationDataCompany(configuration));
        }
    }, [companyViewInfo, companyInfo, companyViewActive, dispatch]);

    const changeCompany = useCallback((idCompany) => {
        const dto = userCompanies.find(p => p.id_company === idCompany);
        if (idCompany !== selectedCompanyId && dto) {
            dispatch(selectCompany(dto));
        }
    }, [dispatch, userCompanies, selectedCompanyId]);

    const startViewAs = useCallback((companyData, global) => {
        if (!companyViewActive) {
            dispatch(startViewAsCompany(companyData));
            if (global)
                dispatch(selectCompany(companyData));

        }
    }, [dispatch, companyViewActive]);

    const endViewAs = useCallback(() => {
        dispatch(endViewAsCompanyAction());
    }, [dispatch]);

    const activeCompanyInfo = companyViewActive ? companyViewInfo : companyInfo;
    const activeCompanyId = companyViewActive ? companyViewSelectedId : selectedCompanyId;

    return {
        companyInfo: activeCompanyInfo,
        activeCompanyId,
        userCompanies,
        selectedCompanyId,
        isLoading,
        error,
        hasMultipleCompanies: userCompanies.length > 1,
        changeCompany,
        init,
        // Company View (temporal)
        companyViewActive,
        startViewAs,
        endViewAs,
        //
    };
};